import { getters } from "@/constants/state";

export default {
  [getters.FREEDAYS_OVERVIEW_GETTER]: (state) => state.overview,
  [getters.FREEDAYS_USER_FREE_DAYS_GETTER]: (state) => state.userFreeDays,
};
